import { BaseEntity } from "src/shared/interfaces";

import { MemberListItem, Creator } from "src/shared/models";

export enum TeamStatus {
  Active = "Active",
  Archived = "Archived",
}

export interface Team extends BaseEntity {
  members_count?: number;
  members?: MemberListItem[];
  created_by?: string;
  created_at?: string;
  status?: TeamStatus;
  creator?: Creator;
}
